// Generated by scripts/gen-name-colors.mjs from the palette in shared/src/nameColor.ts. Don't edit by hand.
// The palette colors under 3:1 on each theme's message backgrounds (--surface, --ground): the picker's note (#698).
import type { ThemeId } from "./api.ts";

export const NAME_LOW_CONTRAST: Readonly<Record<ThemeId, readonly string[]>> = {
  light: ["#ff8a00", "#ffd60a", "#22b14c", "#00bcd4", "#ffc3bd", "#d7da94", "#88e7ec", "#d3cdff"],
  dark: ["#8e30e8", "#8b5a2b", "#653e00", "#005725", "#004d74", "#6a2a66"],
  midnight: ["#653e00", "#005725", "#004d74", "#6a2a66"],
  dracula: ["#1565ff", "#8e30e8", "#8b5a2b", "#653e00", "#005725", "#004d74", "#6a2a66"],
  nord: ["#e6262a", "#1565ff", "#8e30e8", "#8b5a2b", "#653e00", "#005725", "#004d74", "#6a2a66"],
  gruvbox: ["#8e30e8", "#8b5a2b", "#653e00", "#005725", "#004d74", "#6a2a66"],
  solarized: ["#ff8a00", "#ffd60a", "#22b14c", "#00bcd4", "#8a8a8a", "#ffc3bd", "#d7da94", "#88e7ec", "#d3cdff"],
  latte: ["#ff8a00", "#ffd60a", "#22b14c", "#00bcd4", "#8a8a8a", "#ffc3bd", "#d7da94", "#88e7ec", "#d3cdff"],
};
